import React, { Component, useEffect, useState } from 'react';
import Services from './services';
import './css/email.css';

const Dashboard = (props) => {
  const [ olvasatlan, setOlvasatlan ] = useState(null);
  const [ osszes, setOsszes ] = useState(null);
  const { globals } = props;

  useEffect(() => {
    Services.getLevelszam((err, res) => {
      if (!err) {
        setOlvasatlan(res[0].olvasatlan);
        setOsszes(res[0].osszes);
      }
    });
  })

  const handleUzenetClick = () => {
    console.log(props);
    globals.route.navigate(`${globals.public_url}/admin/dashboard/uzenetek/`);
    // this.props.globals.route.navigate('/dashboard/uzenetek/');
  }
  
  console.log('DASHBOARD PROPS: ', props);
  
  return (
    <div className="animated fadeIn">
      <div className="row">
        <div className="col-sm-6 col-lg-3">
          <div
            className="social-box facebook"
            style={{ cursor: 'pointer' }}
            onClick={handleUzenetClick}
          >
            <i className="fa fa-envelope-o" />
            <div className="chart-wrapper">
              <canvas id="social-box-chart-1" height="90" />
            </div>
            <ul>
              <li>
                <strong>{olvasatlan ? olvasatlan : '-'}</strong>
                <span>OLVASATLAN</span>
              </li>
              <li>
                <strong>{osszes ? osszes : '-'}</strong>
                <span>ÖSSZES</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
